// services/compliance.service.ts
import { apiService } from "../../app.service";

export const complianceApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Template - NO locationId (Common for all)
    fetchCompliances: builder.query({
      query: (type) => ({
        url: "/compliance",
        params: { type },
      }),
      providesTags: ["compliances"],
    }),
    
    fetchComplianceById: builder.query({
      query: (id) => ({
        url: `/compliance/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "compliance", id: result._id }] : [],
    }),
    
    createCompliance: builder.mutation({
      query: (data) => ({
        url: "/compliance",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["compliances"],
    }),
    
    updateCompliance: builder.mutation({
      query: ({ id, data }) => ({
        url: `/compliance/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "compliance", id },
        "compliances",
      ],
    }),
    
    deleteCompliance: builder.mutation({
      query: (data) => ({
        url: "/compliance/" + data,
        method: "DELETE",
      }),
      invalidatesTags: ["compliances"],
    }),
    
    reorderCompliance: builder.mutation({
      query: ({ type, data }) => ({
        url: "/compliance/reorder/" + type,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["compliances"],
    }),
    
    // ✅ SUBMISSION - NEEDS locationId (Location-specific)
    fetchCompliancesWithSubmission: builder.query({
      query: ({ type, locationId }) => ({
        url: "/compliance/submission",
        params: { 
          type,
          ...(locationId && { locationId }) // ✅ Pass locationId
        },
      }),
      providesTags: ["complianceSubmissions"],
    }),
    
    createComplianceSubmission: builder.mutation({
      query: ({ data, locationId }) => ({
        url: "/complianceSubmission",
        method: "POST",
        body: data,
        ...(locationId && { params: { locationId } }), // ✅ Pass locationId
      }),
      invalidatesTags: ["complianceSubmissions"],
    }),

    // ============================================
    // ✅ DOCUMENTATION ENDPOINTS
    // ============================================
    
    // ✅ Get documentation by type
    getDocumentation: builder.query({
      query: ({ type, locationId }) => ({
        url: `/documentation/${type}`,
        params: {
          ...(locationId && { locationId }),
        },
      }),
      providesTags: ["documentation"],
    }),
    
    // ✅ Get all documentation
    getAllDocumentation: builder.query({
      query: ({ locationId }) => ({
        url: "/documentation",
        params: {
          ...(locationId && { locationId }),
        },
      }),
      providesTags: ["documentation"],
    }),
    
    // ✅ Upload/Update documentation
    upsertDocumentation: builder.mutation({
      query: ({ data, locationId }) => ({
        url: "/documentation",
        method: "POST",
        body: data,
        ...(locationId && { params: { locationId } }),
      }),
      invalidatesTags: ["documentation"],
    }),
    
    // ✅ Delete documentation
    deleteDocumentation: builder.mutation({
      query: ({ type, locationId }) => ({
        url: `/documentation/${type}`,
        method: "DELETE",
        params: {
          ...(locationId && { locationId }),
        },
      }),
      invalidatesTags: ["documentation"],
    }),
  }),
});

export const {
  useFetchCompliancesQuery,
  useFetchComplianceByIdQuery,
  useCreateComplianceMutation,
  useUpdateComplianceMutation,
  useDeleteComplianceMutation,
  useReorderComplianceMutation,
  useFetchCompliancesWithSubmissionQuery,
  useCreateComplianceSubmissionMutation,
 useGetDocumentationQuery,
  useGetAllDocumentationQuery,
  useUpsertDocumentationMutation,
  useDeleteDocumentationMutation,

} = complianceApi;